import React, { useEffect, useState } from 'react';

import { APIROOT } from '../../Helpers/configs';

import { Grid, Typography, TextField } from '@mui/material';

import { convertDate } from '../../Helpers/helpers';

const JobCardCustomerInfo = (props) => {
  const timeData = props.timeData;
  const jobcardInfo = props.jobcardInfo;
  // const orderNo = props.orderNo;
  // const grnNo = props.grnNo;
  const setJobcardInfo = props.setJobcardInfo;
  const [timeIn, setTimeIn] = useState('');

  const [customerInfo, setCustomerInfo] = useState({
    ...props.customerData,
    time_in: timeIn,
    time_out: convertDate(
      new Date() === undefined
        ? 'Thu Jan 19 2023 15:02:56 GMT+0200 (South Africa Standard Time)'
        : new Date(),
      0,
      17
    ),
  });

  useEffect(() => {
    checkClock(props.customerData.id).then((data) => {
      setTimeIn(convertDate(data.data.value.first_start_ts));
      setCustomerInfo({
        ...props.customerData,
        time_in: convertDate(data.data.value.first_start_ts, 0, 17),
        time_out: convertDate(
          new Date() === undefined
            ? 'Thu Jan 19 2023 15:02:56 GMT+0200 (South Africa Standard Time)'
            : new Date(),
          0,
          17
        ),
        date_today: convertDate(
          new Date() === undefined
            ? 'Thu Jan 19 2023 15:02:56 GMT+0200 (South Africa Standard Time)'
            : new Date(),
          0,
          10
        ),
      });
      // setCustomerInfo.time_in(data.data.value.first_start_ts);
    });
  }, [jobcardInfo, props]);

  const [orderNumber, setOrderNumber] = useState(
    props.jobcardInfo.order_number
  );
  const [grnNumber, setGrnNumber] = useState(props.jobcardInfo.grn_number);

  // useEffect(
  //   (timeData) => {
  //     // let tval = convertDate(timeData);
  //     setTimeIn(timeData);
  //     console.log(timeData);
  //   },
  //   [timeData]
  // );

  useEffect(() => {
    let order = jobcardInfo.order_number;
    let time = timeData;
    // console.log(order);
    setOrderNumber(order);
    setTimeIn(time);
  }, [jobcardInfo, timeData]);

  useEffect(() => {
    let grn = jobcardInfo.grn_number;
    setGrnNumber(grn);
  }, [jobcardInfo]);

  //Will change when endpoints are ready

  //Defining and returning grid blocks with elements
  const infoBlock = (
    key,
    title,
    info,
    titleGridLarge,
    titleGridSmall,
    infoGridLarge,
    infoGridSmall
  ) => {
    return (
      <>
        <Grid
          item
          border={'grey solid 1px'}
          // xs={titleGridSmall}
          md={titleGridLarge}
          sx={{
            '@media print': { width: titleGridSmall === 4 ? '20%' : '10%' },
            width: '100%',
          }}
          style={{
            textAlign: 'left',
            borderRight: 'none',
            borderBottom:
              title === 'Store Order Number/s:' || title === 'GRN Number:'
                ? 'grey solid 1px'
                : 'none',
          }}
        >
          <Typography fontWeight='700' variant='subtitle1'>
            {title}
          </Typography>
        </Grid>
        <Grid
          item
          border={'grey solid 1px'}
          // xs={infoGridSmall}
          md={infoGridLarge}
          sx={{
            '@media print': { width: infoGridSmall === 8 ? '30%' : '15%' },
            width: '100%',
          }}
          style={{
            textAlign: 'left',
            borderLeft: 'none',
            borderBottom:
              title === 'Store Order Number/s:' || title === 'GRN Number:'
                ? 'grey solid 1px'
                : 'none',
          }}
        >
          {title === 'Store Order Number/s:' || title === 'GRN Number:' ? (
            <TextField
              size='small'
              id={key}
              fullWidth
              name={key}
              defaultValue={info}
              // defaultValue={key === 'order_number' ? orderNumber : grnNumber}
              onChange={(event) =>
                // console.log(event.target.id, event.target.value)
                setJobcardInfo(event.target.id, event.target.value)
              }
            />
          ) : (
            <Typography variant='subtitle1'>
              {key === 'date_logged' ? convertDate(info, 0, 17) : info}
            </Typography>
          )}
        </Grid>
      </>
    );
  };

  //Define Items and the order of the blocks
  //[ Title, PC Grid Size for Title, Mobile Grid Size for Title, PC Grid Size for Info, Mobile Grid Size for Info, Build order ]
  const defineBlocks = (dataItem) => {
    switch (dataItem) {
      case 'customer_name':
        return ['Store Name:', 2, 4, 4, 8, '1'];
      case 'date_today':
        return ['Date:', 1, 4, 5, 8, '2'];
      case 'customer_address':
        return ['Address:', 2, 4, 4, 8, '3'];
      case 'time_in':
        return ['Time In:', 1, 2, 2, 4, '4'];
      case 'time_out':
        return ['Time Out:', 1, 2, 2, 4, '5'];
      case 'customer_contact_name':
        return ['Contact Name:', 2, 4, 4, 8, '6'];
      case 'customer_contact_number':
        return ['Contact Number:', 2, 4, 4, 8, '6'];
      case 'customer_branchcode':
        return ['Branch Code:', 2, 4, 4, 8, '7'];
      case 'wi_number':
        return ['WO Number:', 2, 4, 4, 8, '8'];
      case 'order_number':
        return ['Store Order Number/s:', 2, 4, 4, 8, '9'];
      case 'grn_number':
        return ['GRN Number:', 2, 4, 4, 8, '10'];
      default:
        return ['NotDefined'];
    }
  };

  const createBlocks = (obj) => {
    //Prepare build blocks from object
    let returnBlocks = [];
    Object.keys(obj).forEach((key) => {
      let blockData = defineBlocks(key);
      if (blockData[0] !== 'NotDefined') {
        returnBlocks = [
          ...returnBlocks,
          {
            key: key,
            id: blockData[5],
            title: blockData[0],
            info: obj[key],
            titleGridLarge: blockData[1],
            titleGridSmall: blockData[2],
            infoGridLarge: blockData[3],
            infoGridSmall: blockData[4],
          },
        ];
      }
    });
    //Sort and build grid blocks
    return returnBlocks
      .sort((a, b) => a.id - b.id)
      .map((item) =>
        infoBlock(
          item.key,
          item.title,
          item.info,
          item.titleGridLarge,
          item.titleGridSmall,
          item.infoGridLarge,
          item.infoGridSmall
        )
      );
  };

  return (
    <>
      {createBlocks(customerInfo)}
      <Grid
        item
        border={'grey solid 1px'}
        // xs={4}
        md={2}
        style={{
          textAlign: 'left',
          borderRight: 'none',
          borderBottom: 'grey solid 1px',
        }}
        sx={{
          '@media print': { width: '20%' },
          width: '100%',
        }}
      >
        <Typography fontWeight='700' variant='subtitle1'>
          Store Order Number/s
        </Typography>
      </Grid>
      <Grid
        item
        border={'grey solid 1px'}
        // xs={8}
        md={4}
        style={{
          textAlign: 'left',
          borderLeft: 'none',
          borderBottom: 'grey solid 1px',
        }}
        sx={{
          '@media print': { width: '30%' },
          width: '100%',
        }}
      >
        <TextField
          className='input-print-style'
          size='small'
          id='order_number'
          fullWidth
          name='order_number'
          sx={{
            background:
              orderNumber === undefined || orderNumber === ''
                ? '#00334433'
                : 'none',
          }}
          value={orderNumber}
          onChange={(event) =>
            setJobcardInfo(event.target.id, event.target.value)
          }
        />
      </Grid>
      <Grid
        item
        border={'grey solid 1px'}
        // xs={4}
        md={2}
        style={{
          textAlign: 'left',
          borderRight: 'none',
          borderBottom: 'grey solid 1px',
        }}
        sx={{
          '@media print': { width: '20%' },
          width: '100%',
        }}
      >
        <Typography fontWeight='700' variant='subtitle1'>
          GRN Number
        </Typography>
      </Grid>
      <Grid
        item
        border={'grey solid 1px'}
        // xs={8}
        md={4}
        style={{
          textAlign: 'left',
          borderLeft: 'none',
          borderBottom: 'grey solid 1px',
        }}
        sx={{
          '@media print': { width: '30%' },
          width: '100%',
        }}
      >
        <TextField
          className='input-print-style'
          size='small'
          id='grn_number'
          fullWidth
          name='grn_number'
          sx={{
            background:
              grnNumber === undefined || grnNumber === ''
                ? '#00334433'
                : 'none',
          }}
          value={grnNumber}
          // defaultValue={key === 'order_number' ? orderNumber : grnNumber}
          onChange={
            (event) => setJobcardInfo(event.target.id, event.target.value)
            // console.log(event.target.id, event.target.value)
          }
        />
      </Grid>
    </>
  );
};

export default JobCardCustomerInfo;

async function checkClock(ticketId) {
  let JWT = localStorage.getItem('JWT_Key');
  let headers = {
    'content-type': 'application/JSON',
  };
  if (JWT) {
    headers['x-api-key'] = JWT;
  }
  let body = {
    fetch: 'ticket_hours_repair',
    fetchid: ticketId,
  };
  const request = new Request(`${APIROOT}/api/actions`, {
    method: 'post',
    headers,
    body: JSON.stringify(body),
  });
  const response = await fetch(request);

  const data = response.json();
  return data;
}
